const images = {
  logoW: require('src/assets/images/logo-blue.png'),
  logo2: require('src/assets/images/7icon.png'),
  logo: require('src/assets/images/logo.svg').default,
  auth: {
    authBg: require('src/assets/images/auth/auth-bg.png'),
    login1: require('src/assets/images/auth/login-1.png'),
  },
};

export default images;
